const npcMap = {
    Glyde: {
        key: "npc_glyde",
        url: require("../GameMaps/VoidCity/npcGlyde.png"), // ✅ local file
        x: 400,
        y: 300,
        scale: 0.05,
        flipX: false,

    },
    // Add more NPCs here
    RedOrb: {
        key: "npc_red_orb",
        url: require("../sprites/infinityOrb-ns-sprite.png"),
        frameWidth: 187,
        frameHeight: 188, // Example frame size
        scale: 0.3,
    },
    BlueOrb: {
        key: "npc_blue_orb",
        url: require("../sprites/infinityOrb-ns-sprite.png"),
        frameWidth: 187,
        frameHeight: 188, // Example frame size
        scale: 0.3,
    },
    GreenOrb: {
        key: "npc_green_orb",
        url: require("../sprites/infinityOrb-ns-sprite.png"),
        frameWidth: 187,
        frameHeight: 188, // Example frame size
        scale: 0.3,
    },
    EvilOrb: {
        key: "npc_evil_orb",
        url: require("../sprites/infinityOrb-ns-sprite.png"),
        frameWidth: 187,
        frameHeight: 188,
        scale: 0.3,                 // tune as you like
        tint: 0x9b5cf6,              // purple
        ai: "chaser",                // 👈 behavior flag
        speed: 1.2,                  // chaser base speed
        aggroRange: 80,             // start chasing within this radius
        giveUpRange: 100,            // drop aggro if player leaves this
    },
};

export default npcMap;